<template>
  <div class="dispatch-map">
    <pages-header :queryParams="queryParams"></pages-header>
    <div class="map-box">
      <div id="container"></div>
      <div class="check-in-record" @click="handleToCheckInRecord">
        <div class="icon-shield-fill-box">
          <i class="iconfont icon-shield-fill"></i>
        </div>
        查看打卡记录
        <i class="iconfont icon-qianjin"></i>
      </div>
      <div
        class="refresh-button"
        :class="{'refresh-button-active': !refreshLoading}"
        @click="handleRefresh"
      >
        <van-loading size="16px" v-if="refreshLoading"></van-loading>
        <i class="iconfont icon-refresh" v-else></i>
      </div>
    </div>
    <check-in-info
      ref="checkInInfoRef"
      :mapLoaded="mapLoaded"
      :getCenterLoading="getCenterLoading"
      :queryParams.sync="queryParams"
      :checkInRangeValue="checkInRangeValue"
      :refreshLoading="refreshLoading"
      @refresh="handleRefresh"
    />
  </div>
</template>

<script>
import checkInInfo from "./components/check-in-info.vue";
import { getDict } from "@/api/material/index.js";
import { Image, Loading, Search } from "vant";
import permission from "@/utils/permission.js"
import Vconsole from "vconsole";
import eventBus from "@/utils/bus.js";
import pagesHeader from "./components/pages-header.vue";

var getLocationResolveReject = {};
function appGetLocationFinish(data){
  if(!getLocationResolveReject.resolve || !getLocationResolveReject.reject) return;
  eventBus.$emit("appGetLocationFinish",data);
  getLocationResolveReject = {};
}
window.appGetLocationFinish = appGetLocationFinish;

export default {
  components: {
    pagesHeader,
    checkInInfo,
    [Image.name]: Image,
    [Loading.name]: Loading,
    [Search.name]: Search,
  },
  data() {
    return {
      map: null,
      mapZoomAntiShakeTimer: null, //地图缩放防抖计时器
      getCenterLoading: false, //获取中心点loading
      showIdentification: false, //显示地址识别框
      //手机当前位置
      locationPhoneInfo: {
        province: "", //省
        city: "", //市
        district: "", //区
        detailedAddress: "", //详细地址
        title: "", //标题
        latitude: "",
        longitude: "",
      },
      queryParams: {},
      mapLoaded: false, //地图加载完毕(瓦片全部显示)
      watchPositionInfo: {},
      mapPanendSource: "", //地图平移操作来源
      marker:null,  //地图点标记实例
      circle: null,
      refreshCount: 0,
      refreshLoading: false,
      checkInRangeValue: 0,  //打卡点范围半径，单位：米
    };
  },
  created() {
    process.env.NODE_ENV === 'development' && new Vconsole();
    eventBus.$on("appGetLocationFinish",this.appGetLocationFinish);
  },
  mounted() {
    this.createMap().then(() => {
      this.initMap();
      this.initData();
    });
  },
  beforeDestroy(){
    eventBus.$off("appGetLocationFinish",this.appGetLocationFinish);
  },
  methods: {
    appGetLocationFinish(data){
      data = data && this.$test.jsonString(data) ? JSON.parse(data) : data;
      if(data.error) {
        getLocationResolveReject.reject && getLocationResolveReject.reject(data.error);
      }else {
        getLocationResolveReject.resolve && getLocationResolveReject.resolve(data);
      };
      this.$set(this.queryParams,"deviceLatLng",{
        latitude: +data.latitude || null,
        longitude: +data.longitude || null,
      });
      this.refreshLoading = false;
    },
    /* 城市选择确认
     * 调用搜索列表的搜索功能
     */
    handleCityConfirm() {
      this.$refs["searchList"].handleQuery();
    },
    /** 数据初始化 */
    initData() {
      let query = this.$route.query;
      this.queryParams = this.deepClone({
        ...query,
        deviceLatLng: query.deviceLatLng && JSON.parse(query.deviceLatLng),
        checkInLatLng: query.checkInLatLng && JSON.parse(query.checkInLatLng),
      });
      console.log("query",this.deepClone(this.queryParams))
      // this.handleRefresh();
    },
    async initMap() {
      if (this.map) return;
      //初始化地图
      this.map = new window.TMap.Map("container", {
        rotation: 0,//设置地图旋转角度
        pitch: 0, //设置俯仰角度（0~45）
        zoom: 10,//设置地图缩放级别
        mapStyleId: "style1" //设置样式ID
      });
      this.map.on("tilesloaded", this.mapTilesloaded);
    },
    // 跳转到签到记录
    handleToCheckInRecord(){
      let url = "";
      if(this.queryParams.port === "handler"){
        url = "/packMaterial/home/checkInRecord/index";
      }else if(this.queryParams.port === "discharger") {
        url = "/packWarehouse/home/checkInRecord/index";
      }
      window.uni.navigateTo({ url });
    },
    // 刷新
    async handleRefresh(){
      if(this.refreshLoading) return;
      this.reset();
      await this.getLocation();
      /* if(this.refreshCount && process.env.NODE_ENV === "production") {
        console.log("handleRefresh getLocation",this.refreshCount,process.env.NODE_ENV)
        await this.getLocation();
      } */
      this.refreshCount++;
      let checkInLatLng = this.queryParams.checkInLatLng || {};
      let fromToList = [
        {
          id: "device-location",
          styleId:"device-location",
          position:new TMap.LatLng(+this.queryParams.deviceLatLng.latitude,+this.queryParams.deviceLatLng.longitude),
        },
        {
          id: "check-in-point",
          styleId:"check-in-point",
          position:new TMap.LatLng(+checkInLatLng.latitude,+checkInLatLng.longitude),
        }
      ];
      console.log("执行了刷新",this.deepClone(this.queryParams))
      // 计算传入路径的距离之和(单位：米)
      this.computeDistance(fromToList);
      //添加起始点和车辆点标记
      this.handleMultiMarker(fromToList);  
      // 设置可打卡点圆形范围
      this.handleMultiCircle(fromToList);
      // 设置地图可视范围
      this.handleLatLngBounds(fromToList);
    },
    getLocation(){
      return new Promise(async(resolve,reject) => {
        try {
          if(!window.plus) return resolve(this.queryParams.deviceLatLng);
          console.log("getLocation window.plus",window.plus);
          console.log("getLocation window.uni.postMessage",window.uni.postMessage);
          this.refreshLoading = true;
          getLocationResolveReject = { resolve, reject };
          let PermissionResult = await permission.appPermission({ iosKey:'location', androidKey:'ACCESS_FINE_LOCATION' });
          console.log('位置权限成功开启',JSON.stringify(PermissionResult));
          // 5+API 获取不了小屏PDA的系统位置，APP的定位模块只配置了系统定位和腾讯SDK
          await this.$sleep(1000);
          window.uni.postMessage({
            data: {
              type: "getLocation"
            }
          });
          /* let position = await this.handleGetLocation();
          if(!position.lat || !position.lng || position.lat == 5e-324 || position.lng == 5e-324 ) throw new Error("经纬度数据异常");
          this.queryParams.deviceLatLng = {
            latitude: position.lat,
            longitude: position.lng,
          };
          this.refreshLoading = false;
          return Promise.resolve(this.queryParams.deviceLatLng); */
        } catch (error) {
          console.log("getLocation error",JSON.stringify(error));
          this.refreshLoading = false;
          this.$dialog.confirm({
            title:'权限提示',
            message:'请在手机中开启定位信息权限',
          }).then(()=>{
            permission.goSystemAppSetting();
          },()=>{});
          return reject(error);
        }
      })
    },
    // 瓦片加载完毕
    mapTilesloaded() {
      this.mapLoaded = true;
      this.map.off("tilesloaded", this.mapTilesloaded);
    },
      // 计算传入路径的距离之和(单位：米)
    computeDistance(latLngList){
      var distance = TMap.geometry.computeDistance(latLngList.map(item => item.position));
      this.$set(this.queryParams,"distance",distance.toFixed(0));
    },
    handleMultiMarker(geometries){
      //标记起终点marker
      let styles = {
        "device-location": new TMap.MarkerStyle({
          width: 50,
          height: 55,
          // 锚点
          anchor: { x: 22.5, y: 60 },
          src: require("@/assets/image/material/device-location.png")
        }),
        "check-in-point": new TMap.MarkerStyle({
          width: 18,
          height: 18,
          anchor: { x: 9, y: 9 },
          src: require("@/assets/image/material/check-in-point.png")
        })
      };
      if(this.marker){
        this.marker.setStyles(styles)
        this.marker.updateGeometries(geometries);//更新mark
      }else{
        this.marker = new TMap.MultiMarker({ 
          id: "marker-layer" + 1,
          map: this.map,
          styles,
          geometries
        });
      };
    },
    // 设置可打卡点圆形范围
    async handleMultiCircle(geometries){
      // 获取字典中领料/卸料点的打卡范围
      let { data: dictData } = await getDict("material_check_in_range");
      let dictActive = dictData.find(dictItem => dictItem.dictLabel === `${this.queryParams.fromTo}_check_in_range`) || {};
      this.checkInRangeValue = +dictActive.dictValue || 0;
      // 找到打卡点的中心坐标
      let checkInPointOption = geometries.find(item => item.id === "check-in-point");
      if(!checkInPointOption || !checkInPointOption.position || !this.checkInRangeValue) return Promise.resolve({
        checkInPointOption,
        checkInRangeValue: this.checkInRangeValue
      });
      this.circle = new TMap.MultiCircle({
          map: this.map, // 指定地图实例
          style: new TMap.CircleStyle({
            color: "rgba(102,158,230,0.2)",
            showBorder: false,
          }),
          geometries: [{
            center: checkInPointOption.position, // 圆心位置
            radius: this.checkInRangeValue, // 圆半径，单位：米
          }]
      });
    },
    // 设置地图可视范围
    handleLatLngBounds(geometries){
      // 自适应显示多个标记及线路
      var bounds = new TMap.LatLngBounds();
      /* 
      var vehicleTrajectoryList = this.vehicleTrajectoryList&&this.vehicleTrajectoryList.length?
      this.vehicleTrajectoryList.map(item=>({position:new TMap.LatLng(item.latitude,item.longitude)})):[];
      var markerArr = vehicleTrajectoryList.concat(geometries) */
      //判断标注点是否在范围内
      geometries.forEach(function(item){
        //若坐标点不在范围内，扩大bounds范围
        if(bounds.isEmpty() || !bounds.contains(item.position)){
            bounds.extend(item.position);
        }
      })
      //设置地图可视范围
      this.map.fitBounds(bounds, {
          padding: 100 // 自适应边距
      });
    },
    reset(){
      if(this.marker) {
        this.marker.setMap(null);
        this.marker = null;
      };
      if(this.circle) {
        this.circle.setMap(null);
        this.circle = null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .mask-style {
  z-index: 9998 !important;
}
::v-deep .rotate-circle {
  display: none !important;
}
::v-deep .tmap-zoom-control {
  display: none !important;
}
::v-deep .tmap-scale-control {
  display: none !important;
}
.dispatch-map {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .map-box {
    flex: 1;
    overflow: hidden;
    position: relative;
    #container {
      width: 100%;
      height: 100%;
    }
    .map-center-box {
      position: absolute;
      left: 50%;
      bottom: 50%;
      transform: translateX(-50%);
      z-index: 9;
      display: flex;
      flex-direction: column;
      align-items: center;
      .chatting {
        box-sizing: border-box;
        // background: url('/src/assets/image/chatting.png') no-repeat left top;
        min-height: 40px;
        overflow: hidden;
        background: url("../../../assets/image/chatting.png") no-repeat left top;
        background-size: 100% 100%;
        padding: 10px 10px 16px 10px;
        font-size: 14px;
        word-break: keep-all;
        text-align: center;
      }
    }
    .check-in-record {
      height: 32px;
      border-radius: 8px;
      box-shadow: 2px 2px 4px 1px rgba(8,55,35,0.16);
      display: inline-flex;
      align-items: center;
      position: absolute;
      right: 12px;
      bottom: 36px;
      z-index: 3000;
      background-color: #F2FCF4;
      padding: 0 4px 0 2px;
      font-size: 16px;
      line-height: 28px;
      color: #12A666;
      user-select: none;
      .icon-shield-fill-box {
        width: 28px;
        height: 28px;
        border-radius: 7px;
        background: linear-gradient( 180deg, #A9D58B 0%, #6AC6A2 100%);
        overflow: hidden;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-right: 8px;
        flex-shrink: 0;
        .iconfont {
          font-size: 18px;
          line-height: 18px;
          color: #FFF;
        }
      }
      .icon-qianjin {
        font-size: 14px;
        line-height: 14px;
        margin-left: 8px;
        flex-shrink: 0;
      }
      &:active {
        opacity: .8;
      }
      
    }
    .refresh-button {
      width: 35px;
      height: 35px;
      position: absolute;
      left: 12px;
      bottom: 36px;
      z-index: 3000;
      background-color: #fff;
      border-radius: 8px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      .iconfont {
        font-size: 16px;
        line-height: 16px;
        color: #3D3833;
      }
    }
    .refresh-button-active {
      &:active {
        opacity: .5;
      }
    }
    .watch-position {
      position: absolute;
      z-index: 9;
      bottom: 50px;
      left: 50%;
      transform: translateX(-50%);
      background-color: #fff;
    }
  }
}
</style>
